<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display:flex;justify-content:flex-start;align-items:center;">
        <div class="btn-box">
          <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">报表时间</span>
          <!-- <el-date-picker v-model="timevalue"  size="small" type="datetimerange" style="width: 360px;" range-separator="至"
                          start-placeholder="开始时间" end-placeholder="结束时间"
                          align="right" value-format="yyyy-MM-dd hh:mm:ss">
          </el-date-picker> -->
          <el-date-picker
            v-model="timevalue"
            style="width: 360px;"
            size="small"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            align="right">
          </el-date-picker>
        </div>
      </div>
      <input-select selectTitle="出入口筛选" :selectKey="'deviceCode'" :selectData="MonitorPointList" style="margin:0 20px" @search="search"/>
      <div style="display: flex;justify-content: space-between">
        <button-export
          :href="exportUrl"
          :beforeDownload="beforeDownload"
          style="margin: 0 0 0 8px"
          v-if="permissionCodes.indexOf('043003001') !== -1"
          download="download.xls"
          value="导出"/>
      </div>
    </div>
    <table-main :selection="false" :hasOperation='false' :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/CustomerFlow";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "video-alarm-record",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "视频报警",
          name: "video-alarm-over-view"
        },
        {
          value: "报警记录"
        }
      ],
      tableHead: [
        {
          prop: "name",
          label: "报警点名称"
        },
        {
          prop: "enterNumber",
          label: "设备名称"
        },
        {
          prop: "outNumber",
          label: "报警类型"
        },
        {
          prop: "name",
          label: "设备报警时间"
        },
        {
          prop: "name",
          label: "设备报警解除时间"
        },
        {
          prop: "name",
          label: "报警持续时间"
        },
        {
          prop: "name",
          label: "状态"
        },
      ],
      requestData: {
        startTime: "",
        endTime: "",
        timeType: "",
        deviceCode: ""
      },
      total: 0,
      pageSize: 10,
      pageNum: 1,
      timeType: "HOUR",
      payStatusList: [],
      tableData: [],
      timevalue: [],
      MonitorPointList: [],
      exportUrl: ""
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getCreatTime();
    this.getMonitorPointList();
  },
  activated() {
    this.getPage();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportStatistics}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&deviceCode=${
        this.requestData.deviceCode
      }&startTime=${this.requestData.startTime}&endTime=${
        this.requestData.endTime
      }&timeType=${this.requestData.timeType}`;
    },
    getCreatTime() {
      this.timevalue = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();

      let curDate = new Date();
      let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000);
      let preYear = preDate.getFullYear();
      let preMonth =
        preDate.getMonth() + 1 < 10
          ? "0" + (preDate.getMonth() + 1)
          : preDate.getMonth() + 1;
      let preDay =
        preDate.getDate() < 10 ? "0" + preDate.getDate() : preDate.getDate();
      if (this.timeType == "HOUR") {
        this.timevalue[0] = year + "-" + month + "-" + date + " 00:00:00";
        this.timevalue[1] = year + "-" + month + "-" + date + " 23:59:59";
      } else if (this.timeType == "DAY") {
        this.timevalue[0] = preYear + "-" + preMonth + "-" + preDay;
        this.timevalue[1] = preYear + "-" + preMonth + "-" + preDay;
      } else if (this.timeType == "MONTH") {
        this.timevalue[0] = year + "-" + month;
        this.timevalue[1] = year + "-" + month;
      }
      this.getPage();
    },
    getPage() {
      this.requestData.timeType = this.timeType;
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0] || "";
        this.requestData.endTime = this.timevalue[1] || "";
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      this.requestData.pageSize = this.pageSize;
      this.requestData.pageNum = this.pageNum;
      this.$axios
        .post(api.getStatisticsPage, this.requestData)
        .then(res => {
          this.total = res.data.data.total;
          let list = res.data.data.list;
          this.tableData = list;
        })
        .catch(errorHandler("获取分页失败"));
    },
    billTabClick() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getCreatTime();
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    getMonitorPointList(searchKey) {
      this.$axios
        .post(api.getMonitorPointList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data;
            list.map(v => {
              v.label = v.name;
              v.key = v.deviceCode;
            });
            this.MonitorPointList = list;
            this.MonitorPointList.unshift({ key: "", label: "全部" });
          }
        })
        .catch(errorHandler("获取出入口信息失败"));
    }
  },
  watch: {
    timevalue() {
      this.getPage();
    }
  }
};
</script>


<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/VideoAlarm/VideoAlarmRecord/VideoAlarmRecord.vue